import React from 'react';

interface PreviewData {
  [key: string]: string;
}

interface DataPreviewProps {
  data: PreviewData[];
  columns: string[];
}

const DataPreview: React.FC<DataPreviewProps> = ({ data, columns }) => {
  return (
    <div className="admin-bulk-upload-preview-section">
      <h3 className="admin-bulk-upload-preview-title">Data Preview</h3>
      <p className="admin-bulk-upload-preview-subtitle">First 5 valid rows</p>

      <table className="admin-bulk-upload-preview-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {Object.values(row).map((value, i) => (
                <td key={i}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataPreview;
